import { render, staticRenderFns } from "./AutoSideTestConfiguration.vue?vue&type=template&id=71d47665&scoped=true"
import script from "./AutoSideTestConfiguration.vue?vue&type=script&lang=js"
export * from "./AutoSideTestConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AutoSideTestConfiguration.vue?vue&type=style&index=0&id=71d47665&prod&lang=css"
import style1 from "./AutoSideTestConfiguration.vue?vue&type=style&index=1&id=71d47665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d47665",
  null
  
)

export default component.exports